import React from "react";
import { Link } from "react-router-dom";
import { useEmployeeApprovers } from "../../api/queries/workflowQueries";
import { getApiErrorMessage } from "../../utils/apiError";
import { ApproverChain } from "./ApproversPage";
import EffectiveApprovers from "../admin/approval-rules/EffectiveApprovers";
import "../admin/admin.css";
import "./approvers.css";

/** Employee profile → Approvers: own chain (level 1 first) + who approves each request type. */
const EmployeeApprovers = ({ employeeId }) => {
  const query = useEmployeeApprovers(employeeId);
  if (query.isLoading)
    return (
      <div className="text-center py-3">
        <span
          className="spinner-border spinner-border-sm text-primary"
          role="status"
          aria-label="Loading"
        ></span>
      </div>
    );
  if (query.isError)
    return (
      <div className="alert alert-danger fs-085 m-0">
        {getApiErrorMessage(query.error, "Could not load the approvers.")}
      </div>
    );
  const data = query.data || {};
  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <ApproverChain approvers={data.approvers || []} />
        <Link
          to={`/employee/approvers?search=${encodeURIComponent(data.employeeNumber || "")}`}
          className="fs-080"
        >
          <i className="bi bi-pencil me-1"></i>Change approvers
        </Link>
      </div>
      {(data.byType || []).length > 0 && (
        <details className="mt-2">
          <summary className="fs-080 text-slate-600">
            Who approves each request type
          </summary>
          <div className="mt-2">
            <EffectiveApprovers byType={data.byType} compact />
          </div>
        </details>
      )}
    </>
  );
};

export default EmployeeApprovers;
